import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, ExternalLink, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { createPortalSession, fetchSubscriptionStatus } from "@/lib/billing";
import { getApiErrorMessage } from "@/lib/api";

export default function BillingHub() {
  const [loading, setLoading] = useState(true);
  const [portalLoading, setPortalLoading] = useState(false);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    fetchSubscriptionStatus().then(setSubscription).catch((err) => {
      toast.error(getApiErrorMessage(err, "Errore caricamento billing"));
    }).finally(() => setLoading(false));
  }, []);

  const openPortal = async () => {
    setPortalLoading(true);
    try {
      const data = await createPortalSession();
      if (data?.portal_url) {
        window.location.href = data.portal_url;
        return;
      }
      toast.error("Portale Stripe non disponibile");
    } catch (err) {
      toast.error(getApiErrorMessage(err, "Errore apertura portale Stripe"));
    } finally {
      setPortalLoading(false);
    }
  };

  if (loading) return <div className="p-10 text-slate-500">Caricamento billing...</div>;

  return (
    <div className="p-6 md:p-10 max-w-5xl">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-sky-700 mb-2">Billing</div>
        <h1 className="font-display font-black text-4xl md:text-5xl">Abbonamento e pagamenti</h1>
        <p className="text-slate-500 mt-2 max-w-2xl text-sm">Questa area collega tenant e piani Stripe. Qui puoi vedere stato piano, periodo attivo e gestire upgrade o portale cliente.</p>
      </div>

      <div className="grid gap-6 md:grid-cols-[1.1fr_0.9fr]">
        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3 text-slate-950"><CreditCard className="h-5 w-5 text-sky-600" /> <span className="font-semibold">Stato attuale</span></div>
          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Piano</div>
              <div className="mt-2 text-2xl font-display font-black text-slate-950">{subscription?.plan_name || "Nessun piano attivo"}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Stato</div>
              <div className="mt-2 text-lg font-semibold text-slate-950">{subscription?.subscription_status || "inactive"}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Scadenza</div>
              <div className="mt-2 text-sm text-slate-700">{subscription?.current_period_end || "Da definire"}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Tenant</div>
              <div className="mt-2 text-sm text-slate-700">{subscription?.tenant_name || "Tenant non associato"}</div>
            </div>
          </div>
        </div>

        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
          <div className="text-sm font-semibold text-slate-950">Azioni</div>
          <div className="mt-5 space-y-3">
            <Button asChild className="w-full rounded-full bg-[#0f172a] hover:bg-slate-800"><Link to="/pricing">Upgrade o nuovo piano</Link></Button>
            <Button onClick={openPortal} variant="outline" className="w-full rounded-full border-slate-300 bg-white" disabled={portalLoading}>
              {portalLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ExternalLink className="h-4 w-4" />} Apri portale Stripe
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
